import React from 'react';
import { useParams } from 'react-router-dom';

interface PrivacyContentProps {
  serviceKey?: string; // Make serviceKey optional for flexibility in dialogs
}

const PrivacyPageContent: React.FC<PrivacyContentProps> = ({ serviceKey: propServiceKey }) => {
  const params = useParams<{ serviceKey: string }>();
  const serviceKey = propServiceKey || params.serviceKey;

  return (
    <div className="text-foreground">
      <h2 className="text-2xl font-semibold mb-4">Privacy Policy</h2>
      <p className="mb-4 text-sm text-foreground-muted">
        Welcome to {serviceKey || 'our service'}! This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
      </p>
      <div className="space-y-3 text-sm">
        <section>
          <h3 className="font-medium mb-1">1. Information We Collect</h3>
          <p className="text-foreground-muted">
            We may collect personal information that you provide to us directly, such as your name, email address, phone number, and payment information when you register for an account, make a booking, or communicate with us. We may also collect non-personal information, such as browser type, operating system, and usage details.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">2. How We Use Your Information</h3>
          <p className="text-foreground-muted">
            We use the information we collect to: provide, operate, and maintain our services; process your transactions; send you confirmations and updates; respond to your comments and questions; improve our services; monitor and analyze trends, usage, and activities; and for other customer service purposes.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">3. How We Share Your Information</h3>
          <p className="text-foreground-muted">
            We do not sell your personal information. We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, and hosting services. We may also share information if required by law or to protect our rights.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">4. Data Security</h3>
          <p className="text-foreground-muted">
            We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">5. Your Data Rights</h3>
          <p className="text-foreground-muted">
            You may have certain rights regarding your personal information, including the right to access, correct, or delete your data. To exercise these rights, please contact us.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">6. Cookies and Tracking Technologies</h3>
          <p className="text-foreground-muted">
            We may use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">7. Changes to This Privacy Policy</h3>
          <p className="text-foreground-muted">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>
        <section>
          <h3 className="font-medium mb-1">8. Contact Us</h3>
          <p className="text-foreground-muted">
            If you have any questions about this Privacy Policy, please contact us at privacy@{serviceKey || 'example'}.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPageContent;
